/* unplugin-vue-components disabled */import { render } from "./E808BRender.vue?vue&type=template&id=1c4aad50&scoped=true"
import script from "./E808BRender.vue?vue&type=script&lang=js"
export * from "./E808BRender.vue?vue&type=script&lang=js"

import "./E808BRender.vue?vue&type=style&index=0&id=1c4aad50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4aad50"]])

export default __exports__